<template>
  <div>
    <div class="searchDiv">
      <el-button v-if="hasPer('prod:platform:add')" @click="editProductDate" style="float: right;">新增</el-button>
    </div>
    <el-table :data="tableData" row-key="id" border height="calc(100vh - 180px)" max-height="calc(100vh - 180px)">
      <el-table-column label="序号" type="index" width="60"></el-table-column>
      <el-table-column label="名称" prop="name"></el-table-column>
      <el-table-column label="操作时间" prop="updateTime"></el-table-column>
      <el-table-column label="操作人" prop="updater"></el-table-column>
      <el-table-column label="操作" prop="option" width="220px" align="center">
        <template slot-scope="scope">
          <el-button v-if="hasPer('prod:platform:edit')" type="primary" @click="editProductDate(JSON.parse(JSON.stringify(scope.row)))">编辑</el-button>
          <el-button v-if="hasPer('prod:platform:del')" type="danger" @click="delProductDate(scope.row.id, scope.row.roleName)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--编辑-->
    <edit-product-date :dialog-visible.sync="dialogVisible" :product-date-obj="productDateObj" @get-list="getProductDateList"></edit-product-date>
  </div>
</template>

<script>
import editProductDate from "./editPlatform.vue";
import {getPlatformList,delPlatform} from "@/api/prod/platform/platform";
import {infoMsg, successMsg} from "../../../utils/message";
import {hasPer} from "../../../utils/common";

export default {
  name: "platform",
  components: {
    editProductDate
  },
  data(){
    return{
      blurry: '',
      tableData: [],
      dialogVisible: false,
      productDateObj: {},
    }
  },
  mounted() {
    this.getProductDateList()
  },
  methods: {
    hasPer,
    //  获取列表
    getProductDateList(){
      getPlatformList().then(res => {
        this.tableData = res
        this.productDateObj={}
      })
    },
    //  编辑角色
    editProductDate(row){
      this.dialogVisible = true
      this.productDateObj = row.id ? row : {}
    },
    //  删除角色
    delProductDate(id, name){
      this.$confirm('确定删除融资周期【'+name+'】？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delPlatform({id: id}).then(() => {
          successMsg('操作成功')
          this.getProductDateList()
        })
      }).catch(() => {
        infoMsg('操作已取消')
      })
    }
  }
}
</script>

<style scoped>

</style>